import { render } from "./Software.vue?vue&type=template&id=db6ea3cc&scoped=true"
import script from "./Software.vue?vue&type=script&lang=js"
export * from "./Software.vue?vue&type=script&lang=js"

import "./Software.vue?vue&type=style&index=0&id=db6ea3cc&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db6ea3cc"]])

export default __exports__